import React from 'react';

import { fg } from '@atlaskit/platform-feature-flags';

export const SharePointSearchResultIcon = () => {
	return fg('rovo_search_custom_icon_component') ? (
		<svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
			<g clipPath="url(#clip0_2230_18933)">
				<path
					d="M20.349 22.1428C24.9728 22.1428 28.7211 18.3053 28.7211 13.5714C28.7211 8.83755 24.9728 4.99999 20.349 4.99999C15.7252 4.99999 11.9769 8.83755 11.9769 13.5714C11.9769 18.3053 15.7252 22.1428 20.349 22.1428Z"
					fill="#036C70"
				/>
				<path
					d="M27.3253 29.2857C31.5638 29.2857 34.9997 25.768 34.9997 21.4286C34.9997 17.0892 31.5638 13.5714 27.3253 13.5714C23.0868 13.5714 19.6509 17.0892 19.6509 21.4286C19.6509 25.768 23.0868 29.2857 27.3253 29.2857Z"
					fill="#1A9BA1"
				/>
				<path
					d="M21.3953 35C24.6705 35 27.3255 32.2817 27.3255 28.9286C27.3255 25.5754 24.6705 22.8571 21.3953 22.8571C18.1201 22.8571 15.4651 25.5754 15.4651 28.9286C15.4651 32.2817 18.1201 35 21.3953 35Z"
					fill="#37C6D0"
				/>
				<path
					opacity="0.1"
					d="M21.7444 12.7357V27.9786C21.7409 28.5082 21.4274 28.984 20.949 29.1857C20.7967 29.2517 20.633 29.2857 20.4676 29.2857H15.4723C15.4653 29.1643 15.4653 29.05 15.4653 28.9285C15.463 28.8093 15.4676 28.6901 15.4793 28.5714C15.607 26.2882 16.9808 24.2736 19.0304 23.3643V22.0357C14.469 21.2956 11.3571 16.9099 12.08 12.2398C12.085 12.2074 12.0902 12.1751 12.0956 12.1428C12.1303 11.9019 12.1792 11.6634 12.2421 11.4286H20.4677C21.1717 11.4313 21.7417 12.0149 21.7444 12.7357Z"
					fill="black"
				/>
				<path
					opacity="0.2"
					d="M19.7695 12.1429H12.0951C11.3198 16.8045 14.3825 21.227 18.9357 22.0207C19.0736 22.0447 19.212 22.0652 19.3509 22.0822C17.1881 23.1322 15.6121 26.1143 15.4781 28.5714C15.4665 28.6901 15.4618 28.8094 15.4641 28.9286C15.4641 29.05 15.4641 29.1643 15.4711 29.2857C15.4837 29.5258 15.514 29.7646 15.5618 30H19.7688C20.2861 29.9965 20.7509 29.6755 20.9479 29.1857C21.0123 29.0298 21.0455 28.8622 21.0455 28.6929V13.45C21.0429 12.7295 20.4733 12.146 19.7695 12.1429Z"
					fill="black"
				/>
				<path
					opacity="0.2"
					d="M19.7701 12.1429H12.0956C11.3205 16.805 14.3837 21.2276 18.9373 22.0212C19.0305 22.0374 19.1239 22.052 19.2175 22.065C17.1245 23.1907 15.6105 26.1657 15.4794 28.5715H19.7701C20.473 28.566 21.0415 27.984 21.0468 27.2643V13.45C21.0441 12.7292 20.4741 12.1456 19.7701 12.1429Z"
					fill="black"
				/>
				<path
					opacity="0.2"
					d="M19.0721 12.1429H12.0954C11.3635 16.5439 14.0571 20.7822 18.2838 21.88C16.6834 23.7521 15.7017 26.0941 15.4791 28.5715H19.0722C19.7762 28.5687 20.3462 27.9851 20.3489 27.2643V13.45C20.3485 12.7283 19.7771 12.1433 19.0721 12.1429Z"
					fill="black"
				/>
				<path
					d="M6.27884 12.1429H19.07C19.7763 12.1429 20.3488 12.7291 20.3488 13.4522V26.5479C20.3488 27.271 19.7763 27.8572 19.07 27.8572H6.27884C5.57255 27.8572 5 27.271 5 26.5479V13.4522C5 12.7291 5.57255 12.1429 6.27884 12.1429Z"
					fill="url(#paint0_linear_sharepoint)"
				/>
				<path
					d="M10.7116 19.84C10.412 19.6365 10.1616 19.3655 9.97978 19.0479C9.80359 18.7158 9.71577 18.3421 9.72513 17.9643C9.70944 17.4528 9.87804 16.9532 10.1988 16.5607C10.536 16.1678 10.9717 15.8768 11.4588 15.7193C12.014 15.5322 12.5955 15.44 13.18 15.4464C13.9486 15.4177 14.7161 15.5277 15.4474 15.7714V17.4143C15.1297 17.2172 14.7836 17.0726 14.4219 16.9857C14.0294 16.8872 13.6267 16.8378 13.2226 16.8386C12.7964 16.8226 12.373 16.9143 11.9898 17.1057C11.6939 17.2364 11.502 17.5344 11.5014 17.8643C11.5002 18.0644 11.5753 18.2571 11.7107 18.4014C11.8706 18.5716 12.0598 18.7101 12.2688 18.81C12.5014 18.9286 12.8502 19.0862 13.3154 19.2829C13.3666 19.2995 13.4165 19.32 13.4647 19.3443C13.9224 19.5275 14.364 19.7504 14.7847 20.0107C15.1032 20.2118 15.3705 20.4875 15.5647 20.815C15.7637 21.1863 15.8602 21.6061 15.8437 22.0293C15.8664 22.5545 15.7095 23.0713 15.4 23.4907C15.0915 23.8763 14.679 24.1605 14.214 24.3079C13.6669 24.4834 13.096 24.5683 12.5228 24.5593C12.0085 24.5617 11.495 24.5187 10.9879 24.4307C10.5598 24.359 10.1419 24.2333 9.74396 24.0564V22.3243C10.1244 22.6025 10.5494 22.8104 10.9998 22.9386C11.4486 23.0818 11.9153 23.1583 12.3854 23.1657C12.8205 23.194 13.2548 23.0996 13.6412 22.8929C13.9118 22.7365 14.0765 22.4403 14.0696 22.1222C14.0714 21.9008 13.9858 21.6881 13.8323 21.5322C13.6415 21.3403 13.4205 21.1827 13.1786 21.0657C12.8996 20.9229 12.4886 20.7346 11.9458 20.5007C11.514 20.323 11.1006 20.1017 10.7116 19.84Z"
					fill="white"
				/>
			</g>
			<defs>
				<linearGradient
					id="paint0_linear_sharepoint"
					x1="7.6664"
					y1="11.1198"
					x2="18.0401"
					y2="28.6688"
					gradientUnits="userSpaceOnUse"
				>
					<stop stopColor="#058F92" />
					<stop offset="0.5" stopColor="#038489" />
					<stop offset="1" stopColor="#026D71" />
				</linearGradient>
				<clipPath id="clip0_2230_18933">
					<rect width="30" height="30" fill="white" transform="translate(5 5)" />
				</clipPath>
			</defs>
		</svg>
	) : (
		<svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
			<g clipPath="url(#clip0_2230_18933)">
				<path
					d="M20.349 22.1428C24.9728 22.1428 28.7211 18.3053 28.7211 13.5714C28.7211 8.83755 24.9728 4.99999 20.349 4.99999C15.7252 4.99999 11.9769 8.83755 11.9769 13.5714C11.9769 18.3053 15.7252 22.1428 20.349 22.1428Z"
					fill="#036C70"
				/>
				<path
					d="M27.3253 29.2857C31.5638 29.2857 34.9997 25.768 34.9997 21.4286C34.9997 17.0892 31.5638 13.5714 27.3253 13.5714C23.0868 13.5714 19.6509 17.0892 19.6509 21.4286C19.6509 25.768 23.0868 29.2857 27.3253 29.2857Z"
					fill="#1A9BA1"
				/>
				<path
					d="M21.3953 35C24.6705 35 27.3255 32.2817 27.3255 28.9286C27.3255 25.5754 24.6705 22.8571 21.3953 22.8571C18.1201 22.8571 15.4651 25.5754 15.4651 28.9286C15.4651 32.2817 18.1201 35 21.3953 35Z"
					fill="#37C6D0"
				/>
				<path
					opacity="0.1"
					d="M21.7444 12.7357V27.9786C21.7409 28.5082 21.4274 28.984 20.949 29.1857C20.7967 29.2517 20.633 29.2857 20.4676 29.2857H15.4723C15.4653 29.1643 15.4653 29.05 15.4653 28.9285C15.463 28.8093 15.4676 28.6901 15.4793 28.5714C15.607 26.2882 16.9808 24.2736 19.0304 23.3643V22.0357C14.469 21.2956 11.3571 16.9099 12.08 12.2398C12.085 12.2074 12.0902 12.1751 12.0956 12.1428C12.1303 11.9019 12.1792 11.6634 12.2421 11.4286H20.4677C21.1717 11.4313 21.7417 12.0149 21.7444 12.7357Z"
					fill="black"
				/>
				<path
					opacity="0.2"
					d="M19.7695 12.1429H12.0951C11.3198 16.8045 14.3825 21.227 18.9357 22.0207C19.0736 22.0447 19.212 22.0652 19.3509 22.0822C17.1881 23.1322 15.6121 26.1143 15.4781 28.5714C15.4665 28.6901 15.4618 28.8094 15.4641 28.9286C15.4641 29.05 15.4641 29.1643 15.4711 29.2857C15.4837 29.5258 15.514 29.7646 15.5618 30H19.7688C20.2861 29.9965 20.7509 29.6755 20.9479 29.1857C21.0123 29.0298 21.0455 28.8622 21.0455 28.6929V13.45C21.0429 12.7295 20.4733 12.146 19.7695 12.1429Z"
					fill="black"
				/>
				<path
					opacity="0.2"
					d="M19.7701 12.1429H12.0956C11.3205 16.805 14.3837 21.2276 18.9373 22.0212C19.0305 22.0374 19.1239 22.052 19.2175 22.065C17.1245 23.1907 15.6105 26.1657 15.4794 28.5715H19.7701C20.473 28.566 21.0415 27.984 21.0468 27.2643V13.45C21.0441 12.7292 20.4741 12.1456 19.7701 12.1429Z"
					fill="black"
				/>
				<path
					opacity="0.2"
					d="M19.0721 12.1429H12.0954C11.3635 16.5439 14.0571 20.7822 18.2838 21.88C16.6834 23.7521 15.7017 26.0941 15.4791 28.5715H19.0722C19.7762 28.5687 20.3462 27.9851 20.3489 27.2643V13.45C20.3485 12.7283 19.7771 12.1433 19.0721 12.1429Z"
					fill="black"
				/>
				<path
					d="M6.27884 12.1429H19.07C19.7763 12.1429 20.3488 12.7291 20.3488 13.4522V26.5479C20.3488 27.271 19.7763 27.8572 19.07 27.8572H6.27884C5.57255 27.8572 5 27.271 5 26.5479V13.4522C5 12.7291 5.57255 12.1429 6.27884 12.1429Z"
					fill="#04868B"
				/>
				<path
					d="M10.7116 19.84C10.412 19.6365 10.1616 19.3655 9.97978 19.0479C9.80359 18.7158 9.71577 18.3421 9.72513 17.9643C9.70944 17.4528 9.87804 16.9532 10.1988 16.5607C10.536 16.1678 10.9717 15.8768 11.4588 15.7193C12.014 15.5322 12.5955 15.44 13.18 15.4464C13.9486 15.4177 14.7161 15.5277 15.4474 15.7714V17.4143C15.1297 17.2172 14.7836 17.0726 14.4219 16.9857C14.0294 16.8872 13.6267 16.8378 13.2226 16.8386C12.7964 16.8226 12.373 16.9143 11.9898 17.1057C11.6939 17.2364 11.502 17.5344 11.5014 17.8643C11.5002 18.0644 11.5753 18.2571 11.7107 18.4014C11.8706 18.5716 12.0598 18.7101 12.2688 18.81C12.5014 18.9286 12.8502 19.0862 13.3154 19.2829C13.3666 19.2995 13.4165 19.32 13.4647 19.3443C13.9224 19.5275 14.364 19.7504 14.7847 20.0107C15.1032 20.2118 15.3705 20.4875 15.5647 20.815C15.7637 21.1863 15.8602 21.6061 15.8437 22.0293C15.8664 22.5545 15.7095 23.0713 15.4 23.4907C15.0915 23.8763 14.679 24.1605 14.214 24.3079C13.6669 24.4834 13.096 24.5683 12.5228 24.5593C12.0085 24.5617 11.495 24.5187 10.9879 24.4307C10.5598 24.359 10.1419 24.2333 9.74396 24.0564V22.3243C10.1244 22.6025 10.5494 22.8104 10.9998 22.9386C11.4486 23.0818 11.9153 23.1583 12.3854 23.1657C12.8205 23.194 13.2548 23.0996 13.6412 22.8929C13.9118 22.7365 14.0765 22.4403 14.0696 22.1222C14.0714 21.9008 13.9858 21.6881 13.8323 21.5322C13.6415 21.3403 13.4205 21.1827 13.1786 21.0657C12.8996 20.9229 12.4886 20.7346 11.9458 20.5007C11.514 20.323 11.1006 20.1017 10.7116 19.84Z"
					fill="white"
				/>
			</g>
			<defs>
				<clipPath id="clip0_2230_18933">
					<rect width="30" height="30" fill="white" transform="translate(5 5)" />
				</clipPath>
			</defs>
		</svg>
	);
};
